import React from 'react';
import { Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import { SparkForm, SparkFormImageUploader } from 'sharedComponents/SparkForm';
import Footer from 'components/AuthScreens/Register/Stepper/Footer';

export type CreatorProfileFormValues = {
  image: string;
};

type CreatorProfileFormProps = {
  activeStep: number;
  nextStepHandler: () => void;
  previousStepHandler: () => void;
  creatorProfileCollection?: CreatorProfileFormValues;
  setCreatorProfileCollection: (formValues: CreatorProfileFormValues) => void;
};

function CreatorProfileForm({
  activeStep,
  nextStepHandler,
  previousStepHandler,
  creatorProfileCollection,
  setCreatorProfileCollection,
}: CreatorProfileFormProps) {
  const initialValues = {
    image: '',
  };
  const validationSchema = yup.object().shape({
    image: yup.string().required('Required'),
  });

  const handleSubmit = async (values: CreatorProfileFormValues) => {
    setCreatorProfileCollection(values);
    nextStepHandler();
  };
  return (
    <SparkForm
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSave={handleSubmit}
    >
      <Grid item xs={12}>
        <Typography variant='h5' fontFamily='Mont-semibold' pt={2}>
          Profile Photo
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' pb={2}>
          Add a profile picture so customers know who they're working with.
        </Typography>
      </Grid>
      <SparkFormImageUploader name='image' containerName='app-assets' />
      <Footer
        activeStep={activeStep}
        handleBack={previousStepHandler}
        isLastStep={false}
      />
    </SparkForm>
  );
}

export default CreatorProfileForm;
